import styled from 'styled-components'

export const StyledUnitAddress = styled.div`
  width: 100%;
  .address-note{
    display: flex;
    align-items: center;
    gap: 8px;
    background: linear-gradient(83.1deg, rgba(255, 70, 192, 0.15) 6.87%, rgba(255, 168, 119, 0.15) 105.82%);
    padding: 8px 12px;
    border-radius: 8px;
    margin-bottom: 16px;
  }
  .unit-container{
    display: flex;
    margin-bottom: 8px;
    width: 100%;
    justify-content: space-between;
  }
  .unit-items{
    border-radius: 60px;
    border: none;
    padding: 7px 16px;
    display: flex;
    justify-content: center;
    
    cursor: pointer;
    &[data-active=true]{
      background: #00AB56;
    }
    &[data-disabled=true]{
      *{
        color: #C8CBD4!important;
        cursor: not-allowed!important;
      }
    }
    &[data-size=sm]{
      width: 50%;
    }
  }
  .unit-checkbox-wrapper{
    display: inline-flex;
    align-items: center;
    gap: 8px;
    justify-content: flex-end;
    width: fit-content;
  }
`

export const StyledAddress = styled.div`
  width: 100%;
  .address-container{
    display: flex;
    gap: 16px;
    width: 100%;
    .province-container, .ward-container{
      width: 50%
    }
    &[data-gap='8']{
      gap: 8px
    }
    &[data-block = true]{
      @media screen and (max-width: 1440px) {
        display: block;
          .province-container, .ward-container{
              width: 100%;
          }
          .ward-container{
            margin-top: 24px;
          }
      }
    }
    &[data-size = 'sm']{
      position: relative;
      .validate-group{
         position: absolute;
         left: 0;
         bottom: -20px;
      }
    }
  }
`

export const StyledOldAddress = styled.div`
  width: 100%;
  .address-container{
    display: flex;
    gap: 16px;
    width: 100%;
    .province-container, .district-container, .ward-container{
      width: calc(100%/3)
    }
    &[data-gap='8']{
      gap: 8px
    }
    &[data-block = true]{
      @media screen and (max-width: 1440px) {
        display: block;
          .province-container, .district-container, .ward-container{
              width: 100%;
          }
          .ward-container{
            margin-top: 24px;
          }
      }
    }
    &[data-size = 'sm']{
      position: relative;
      .validate-group{
         position: absolute;
         left: 0;
         bottom: -20px;
      }
    }
  }
`
